import { BcAntenatalRadioTextboxField } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BcAntenatalRadioTextboxField";

class MedicalHistoryInfectiousDiseases {
    public HasInfectiousDiseases?: boolean = null;
    public HasVaricella?: boolean = null;
    public HasHerpesSimplexVirus?: boolean = null;
    public Other: BcAntenatalRadioTextboxField;

    public constructor(fields?: Partial<MedicalHistoryInfectiousDiseases>) {
        Object.assign(this, fields);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }

    public hasSelectedAnyMedicalHistoryInfectiousDiseases(): boolean {
        return this.HasVaricella
            || this.HasHerpesSimplexVirus
            || this.Other.hasSelected();
    }
}

export { MedicalHistoryInfectiousDiseases };
